import * as React from 'react'

// components
import Icon from '../../../../components/ui/Icon/Icon'
import {
  BlockDropdownInput,
  BlockSearchInput,
  Content,
  Header,
  ItemName,
  MainPage,
  NavItem,
  ProfileNav,
  ReturnIcon,
  Title,
  SearchWrapper,
} from './TransportationPage.style'

// data
import {
  MAIN,
  TRANSPORTATION_ROUTES,
  FILTER_LOCATION,
} from '../../../../services/data/profilePages.json'

// controllers
import { doGetTransportationMalls } from '../../../../controllers/Transportaion'

class TransportationPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      // TODO: define initial state
      malls: [],
      mallsFilter: [],
      errors: {},
    }
    // TODO: implement constructor(props)getAllMalls()
    doGetTransportationMalls({
      onSuccess: ({ data }) => {
        this.setState({
          malls: data,
          mallsFilter: data,
        })
      },
      onError: error => {
        const { errors: errorsObj } = this.state
        errorsObj.allMallsError = error.message
        this.setState({ errors: errorsObj })
      },
    })
  }

  searchMall = e => {
    const { malls } = this.state
    const { value: query = '' } = (e || {}).target || {}

    if (query === '') {
      this.setState({
        mallsFilter: malls,
      })
    } else {
      const filter = malls.filter(mall => {
        const mallName = mall.name.toLowerCase()
        let regex = new RegExp(`${query}`, 'gi')
        let matching = mallName.match(regex)
        return matching
      })

      this.setState({
        mallsFilter: filter,
      })
    }
  }

  componentDidMount() {
    // TODO: implement componentDidMount()
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // TODO: implement componentDidUpdate(prevProps, prevState, snapshot)
  }

  render() {
    // TODO: define template
    const { setProfileModalPage, setTransportationMall } = this.props
    console.debug(this.state)
    return (
      <>
        <MainPage show="true" /*show={!selectedFAQ}*/>
          <Header>
            <ReturnIcon onClick={() => setProfileModalPage(MAIN)}>
              <Icon name="slide-left" />
            </ReturnIcon>
            <Title>P2P Routes</Title>
          </Header>
          <Content>
            <SearchWrapper>
              <BlockSearchInput
                placeholder="Search Mall"
                onChange={this.searchMall}
              />
              <BlockDropdownInput
                placeholder="Filter by Loc..."
                onClick={() => setProfileModalPage(FILTER_LOCATION)}
                // onChange={this.searchFAQ}
              />
            </SearchWrapper>
          </Content>

          <ProfileNav>
            {this.state.mallsFilter.length > 0 &&
              this.state.mallsFilter.map(mall => {
                return (
                  <NavItem
                    onClick={() => {
                      setTransportationMall({ ...mall, type: 'mall' })
                      setProfileModalPage(TRANSPORTATION_ROUTES)
                    }}
                  >
                    <ItemName>{mall.name}</ItemName>
                    <Icon name="slide-right" />
                  </NavItem>
                )
              })}
          </ProfileNav>
        </MainPage>
      </>
    )
  }
}

TransportationPage.defaultProps = {
  // TODO: specify default props
}

TransportationPage.propTypes = {
  // TODO: specify prop types
}

export default TransportationPage
